import React from 'react';
import styles from '../draericaferrari2/draericaferrari2.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import HouseIcon from '../../icons/houseIcon.tsx';
import PartnershipIcon from '../../icons/partnershipIcon.tsx';
import MakeIcon from '../../icons/makeIcon.tsx';
import MagazineIcon from '../../icons/magazineIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Draericaferrari2: React.FC = () => {
    return (
        <div className={styles.draericaferrari2}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <h1 className="pt-2">Dra Erica Ferrari</h1>
                    <p>FARMACÊUTICA ESTETA</p>
                    <div className={styles.links}>
                        <>
                            <LinkPersonalizado7
                                href="https://api.whatsapp.com/send/?phone=5517988433441&text=Ola+.+Gostaria+de+agendar+uma+avalia%C3%A7%C3%A3o%E2%80%A6&type=phone_number&app_absent=0"
                                title="WHATSAPP"
                                icon={<WhatsappIcon height="34" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                            <LinkPersonalizado7
                                href="https://maps.app.goo.gl/ejqwdRmqVbGAaaNm9"
                                title="LOCALIZAÇÃO"
                                icon={<MapsIcon height="34" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                            <LinkPersonalizado7
                                href="https://www.instagram.com/draericaferrari"
                                title="INSTAGRAM"
                                icon={<InstagramIcon height="30" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                            <LinkPersonalizado7
                                linkInterno={true}
                                href="/draericaferrari/procedimentos"
                                title="PROCEDIMENTOS"
                                icon={<MakeIcon height="36" width="36" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Draericaferrari2;
